export const TARGET_SELECTOR = '[data-js-lpu-schedule]'

export const TARGET_ATTR_ADDRESS_ID_NAME = 'data-address-id'
